import { GET } from '../request'

export const getFromAsignatura = ({ mes, centro }) =>
  GET('/api/core/contabilidad/pago-tarifa/list/asignatura', { mes, centro })

export const getFromAlumno = ({ alumno }) =>
  GET('/api/core/contabilidad/pago-tarifa/list/alumno', { alumno })
